import { User } from '../hooks/useAuth';

interface HeaderProps {
  user: User | null;
  onLogout: () => void;
}

export default function Header({ user, onLogout }: HeaderProps) {
  const getRoleBadge = (role: string) => {
    const badges: Record<string, string> = {
      DAERAH: 'badge-daerah',
      DESA: 'badge-desa',
      KELOMPOK: 'badge-kelompok',
    };
    return badges[role] || '';
  };

  return (
    <header className="bg-dark-100 border-b border-gray-800">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <span className="text-2xl">🕌</span>
            <div>
              <h1 className="text-xl font-bold text-white">TPA Santri Management</h1>
              <p className="text-xs text-gray-400">Sistem Manajemen Santri Terpadu</p>
            </div>
          </div>

          {user && (
            <div className="flex items-center space-x-4">
              <div className="text-right hidden sm:block">
                <p className="text-sm font-medium text-white">{user.nama}</p>
                <p className="text-xs text-gray-400">{user.username}</p>
              </div>
              <span className={`badge ${getRoleBadge(user.role)}`}>
                {user.role}
              </span>
              {user.desa && (
                <span className="text-xs text-gray-500 hidden md:block">
                  {user.desa.nama}
                </span>
              )}
              {user.kelompok && (
                <span className="text-xs text-gray-500 hidden md:block">
                  {user.kelompok.nama}
                </span>
              )}
              <button
                onClick={onLogout}
                className="btn-secondary text-sm py-1.5 px-3"
              >
                Keluar
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
